/**
 * 商品英文文案（与数据库 id 对应，数据库仍只存中文）
 * 新项目新增商品时在此补充对应 id 即可。
 */
export const PRODUCT_EN_BY_ID = {
  1: {
    name: 'Modern minimalist fabric sofa',
    description:
      'Clean lines and soft upholstery—comfortable fabric made for contemporary homes.',
    details:
      'Dimensions: 220×90×85 cm\nMaterials: high-density foam, solid wood frame, fabric\nColor: grey\nStyle: modern minimalist\nWeight capacity: 300 kg',
  },
  2: {
    name: 'Modern minimalist coffee table',
    description: 'Tempered glass top with a metal frame—sleek and stylish.',
    details:
      'Dimensions: 120×60×45 cm\nMaterials: tempered glass and metal\nColor: black\nStyle: modern minimalist\nWeight capacity: 80 kg',
  },
  3: {
    name: 'Modern minimalist accent chair',
    description: 'Ergonomic design, breathable and comfortable for reading or relaxing.',
    details:
      'Dimensions: 75×80×90 cm\nMaterials: fabric and metal legs\nColor: off-white\nStyle: modern minimalist\nWeight capacity: 120 kg',
  },
  4: {
    name: 'Modern minimalist bookshelf',
    description: 'Open design with generous storage—simple and practical.',
    details:
      'Dimensions: 120×30×180 cm\nMaterials: engineered wood\nColor: white\nStyle: modern minimalist\nWeight capacity: 200 kg',
  },
  5: {
    name: 'Natural oak dining table',
    description: 'Solid oak with natural grain—eco-friendly and healthy.',
    details:
      'Dimensions: 180×90×75 cm\nMaterials: oak\nColor: natural wood\nStyle: natural wood\nWeight capacity: 150 kg',
  },
  6: {
    name: 'Natural wood dining chair',
    description: 'Solid wood frame with a comfortable seat—warm and understated.',
    details:
      'Dimensions: 45×50×85 cm\nMaterials: oak\nColor: natural wood\nStyle: natural wood\nWeight capacity: 120 kg',
  },
  7: {
    name: 'Natural wood side cabinet',
    description: 'Solid wood, multi-tier storage—cozy and natural.',
    details:
      'Dimensions: 100×40×90 cm\nMaterials: oak\nColor: natural wood\nStyle: natural wood\nWeight capacity: 100 kg',
  },
  8: {
    name: 'Natural wood nightstand',
    description: 'Compact and practical—natural wood feel for the bedroom.',
    details:
      'Dimensions: 50×40×55 cm\nMaterials: oak\nColor: natural wood\nStyle: natural wood\nWeight capacity: 50 kg',
  },
  9: {
    name: 'Scandinavian double bed',
    description: 'Minimal design, solid frame with soft upholstery—stable and comfortable.',
    details:
      'Dimensions: 180×200 cm\nMaterials: solid wood and fabric headboard\nColor: white\nStyle: Scandinavian\nWeight capacity: 400 kg',
  },
  10: {
    name: 'Scandinavian lounge chair',
    description: 'Classic silhouette with Nordic-inspired comfort.',
    details:
      'Dimensions: 70×75×85 cm\nMaterials: fabric and wood legs\nColor: light grey\nStyle: Scandinavian\nWeight capacity: 120 kg',
  },
  11: {
    name: 'Scandinavian TV stand',
    description: 'Clean lines with practical media storage.',
    details:
      'Dimensions: 160×40×50 cm\nMaterials: solid wood and board\nColor: white with wood accent\nStyle: Scandinavian\nWeight capacity: 80 kg',
  },
  12: {
    name: 'Scandinavian side table',
    description: 'Compact and versatile—easy Nordic accent.',
    details:
      'Dimensions: 45×45×55 cm\nMaterials: solid wood\nColor: white\nStyle: Scandinavian\nWeight capacity: 30 kg',
  },
  13: {
    name: 'French-style upholstered bed',
    description: 'Elegant curves and velvet upholstery—romantic French flair.',
    details:
      'Dimensions: 180×200 cm\nMaterials: solid wood and velvet\nColor: cream\nStyle: French luxury\nWeight capacity: 400 kg',
  },
  14: {
    name: 'French dressing table',
    description: 'Refined details and mirror—quintessential French charm.',
    details:
      'Dimensions: 100×50×140 cm\nMaterials: solid wood and mirror\nColor: ivory\nStyle: French\nWeight capacity: 50 kg',
  },
  15: {
    name: 'French accent armchair',
    description: 'Graceful shape with plush comfort—classic French style.',
    details:
      'Dimensions: 85×90×95 cm\nMaterials: velvet and solid wood frame\nColor: blush pink\nStyle: French\nWeight capacity: 150 kg',
  },
  16: {
    name: 'French sideboard',
    description: 'Ornate woodwork with generous storage—elegant and functional.',
    details:
      'Dimensions: 140×45×90 cm\nMaterials: solid wood\nColor: ivory\nStyle: French\nWeight capacity: 100 kg',
  },
  17: {
    name: 'American vintage leather sofa',
    description: 'Rich leather and a sturdy frame—timeless American classic.',
    details:
      'Dimensions: 230×95×90 cm\nMaterials: genuine leather and solid wood\nColor: brown\nStyle: American vintage\nWeight capacity: 350 kg',
  },
  18: {
    name: 'American solid wood desk',
    description: 'Substantial hardwood with multiple drawers.',
    details:
      'Dimensions: 140×70×75 cm\nMaterials: walnut\nColor: deep brown\nStyle: American\nWeight capacity: 100 kg',
  },
  19: {
    name: 'American dining table set',
    description: 'Solid wood table with six chairs—perfect for family meals.',
    details:
      'Dimensions: 200×100×75 cm\nMaterials: oak\nColor: deep brown\nStyle: American\nWeight capacity: 200 kg',
  },
  20: {
    name: 'American storage cabinet',
    description: 'Large-capacity storage with vintage hardware—practical and bold.',
    details:
      'Dimensions: 120×45×180 cm\nMaterials: solid wood\nColor: deep brown\nStyle: American\nWeight capacity: 150 kg',
  },
  21: {
    name: 'Mid-century armchair',
    description: 'Retro silhouette in soft velvet—distinctive vintage mood.',
    details:
      'Dimensions: 80×85×85 cm\nMaterials: velvet and wood frame\nColor: forest green\nStyle: mid-century\nWeight capacity: 120 kg',
  },
  22: {
    name: 'Mid-century sideboard',
    description: 'Warm wood with metal pulls—true vintage character.',
    details:
      'Dimensions: 110×40×85 cm\nMaterials: solid wood and metal\nColor: walnut\nStyle: mid-century\nWeight capacity: 80 kg',
  },
  23: {
    name: 'Mid-century dining chair',
    description: 'Classic shape with a cushioned leather seat.',
    details:
      'Dimensions: 45×50×80 cm\nMaterials: solid wood and leather seat\nColor: brown\nStyle: mid-century\nWeight capacity: 120 kg',
  },
  24: {
    name: 'Mid-century coffee table',
    description: 'Rich wood tones with clean lines—nostalgic yet modern.',
    details:
      'Dimensions: 100×60×45 cm\nMaterials: solid wood\nColor: deep brown\nStyle: mid-century\nWeight capacity: 60 kg',
  },
};

/** 与数据库 name 字段一致，用于 id 类型异常或顺序不一致时的回退 */
export const PRODUCT_ZH_NAME_TO_ID = {
  现代简约布艺沙发: 1,
  现代简约茶几: 2,
  现代简约单人椅: 3,
  现代简约书柜: 4,
  原木风实木餐桌: 5,
  原木风餐椅: 6,
  原木风边柜: 7,
  原木风床头柜: 8,
  北欧风双人床: 9,
  北欧风休闲椅: 10,
  北欧风电视柜: 11,
  北欧风边几: 12,
  法式轻奢双人床: 13,
  法式梳妆台: 14,
  法式单人沙发: 15,
  法式餐边柜: 16,
  美式复古沙发: 17,
  美式实木书桌: 18,
  美式餐桌椅组合: 19,
  美式储物柜: 20,
  中古风单人沙发: 21,
  中古风边柜: 22,
  中古风餐椅: 23,
  中古风茶几: 24,
};
